import { APIResponse, PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { deleteAPI, getAPI, postAPI, putAPI } from "../../../api/Networking";
import { GetTasksParams, Task } from "../../../models/TaskTracker/Task";
import { TaskComment } from "../../../models/TaskTracker/TaskComment";

export default class TaskTrackerAPI {
  getProjectOrders = async (search_text: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/projects/order-ids?search_text=${search_text}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getProducts = async (order_id: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/projects/order-id/${order_id}/products`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getAdmin = async (name: string): Promise<APIResponse> => {
    try {
      const response = await getAPI(`/v5/admins?search_text=${name}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  createTask = async (taskDetails: Task): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/tasks`, taskDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  getTasks = async (
    params: GetTasksParams
  ): Promise<PaginatedAPIResponse<Task>> => {
    try {
      const queryParams = new URLSearchParams();

      if (params.page_no) {
        queryParams.append("page_no", params.page_no.toString());
      }
      if (params.limit) {
        queryParams.append("limit", params.limit.toString());
      }

      if (params.sortBy) queryParams.append("sort_by", params.sortBy);

      if (params.sortType) queryParams.append("sort_type", params.sortType);

      if (params.order_id && params.order_id.length > 0) {
        queryParams.append("order_id", params.order_id.join(","));
      }

      if (params.owner_id && params.owner_id.length > 0) {
        queryParams.append("owner_id", params.owner_id.join(","));
      }

      if (params.reporter_id && params.reporter_id.length > 0) {
        queryParams.append("reporter_id", params.reporter_id.join(","));
      }

      if (params.assignee_id && params.assignee_id.length > 0) {
        queryParams.append("assignee_id", params.assignee_id.join(","));
      }

      if (params.status && params.status.length > 0) {
        queryParams.append("status", params.status.join(","));
      }

      if (params.search_text) {
        queryParams.append("search_text", params.search_text);
      }

      const response = await getAPI(
        `/v5/tasks?active=true&${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getTaskDetails = async (task_id: number) => {
    try {
      const response = await getAPI(`/v5/tasks/task-id/${task_id}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  updateTask = async (task: Task): Promise<APIResponse> => {
    try {
      const response = await putAPI(`/v5/tasks`, task);
      return response;
    } catch (error) {
      throw error;
    }
  };

  getTaskComments = async (
    task_id: number
  ): Promise<PaginatedAPIResponse<TaskComment>> => {
    try {
      const response = await getAPI(`/v5/tasks/task-id/${task_id}/comments`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  addTaskComment = async (
    task_id: number,
    message: string,
    parent_id?: number,
    attachments?: string[]
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/tasks/task-id/${task_id}/comment`, {
        message,
        ...(parent_id ? { parent_id } : {}),
        ...(attachments && attachments.length > 0 ? { attachments } : {}),
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  editTaskComment = async (
    task_id: number,
    comment_id: number,
    message: string
  ): Promise<APIResponse> => {
    try {
      const response = await putAPI(
        `/v5/tasks/task-id/${task_id}/comment/${comment_id}`,
        { message }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  deleteTaskComment = async (
    task_id: number,
    comment_id: number
  ): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(
        `/v5/tasks/task-id/${task_id}/comment/${comment_id}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
